import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const appExpireReq = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.appExpire,
    method: 'POST',
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { appExpireReq }
